module.exports = __webpack_public_path__ + "img/carol.a73f2044.png";